// extracted by mini-css-extract-plugin
export default {"Quiz":"debugQuiz_Quiz__F1IXo"};